import { Component, OnInit } from "@angular/core";
import { BigmlFieldDTO } from "@DTOS";

@Component({
    templateUrl: "./tipo-model-configuracion-modal.component.html",
    styleUrls: ["./tipo-model-configuracion-modal.component.scss"]
})
export class TipoModelConfiguracionModalComponent implements OnInit {
    public campo: BigmlFieldDTO = new BigmlFieldDTO();

    constructor() { }

    ngOnInit(): void {
    }

}
